export const getToYearList = (value: number | null) => {
	const currentTime = new Date();
	const year = currentTime.getFullYear();
	const years = [];
	if (value) {
		for (let i = value; i <= year; i++) {
			years.push({ id: `${i}`, value: `${i}` });
		}
	}
	return years;
};
